export default __webpack_public_path__ + "static/media/Prime-up-logo.6c5cb644.png";